<script>
import ClientesService from '@/services/clientes.service';
import Utils from '@/functions/utils';
import spinnerService from '@/services/spinner.service';

export default {

  data() {
    return {
      loading: false,
      errores: {},
      recomendador: {},
      recomendado: {},
    }
  },
  methods: {
    btnCancelar_click() {
      this.$router.push({
        path: `/`
      });
    },
    async btnGuardar_click() {
      if (this.loading) return;
      //VALIDACIONES
      this.errores.ruc = this.recomendador.ruc == null || this.recomendador.ruc.trim() == '';
      this.errores.nombreCompleto = this.recomendador.nombre == null || this.recomendador.nombre.trim() == '';
      this.errores.telefono1 = this.recomendador.telefono == null || this.recomendador.telefono.trim() == '';

      this.errores.nombre = this.recomendado.nombre == null || this.recomendado.nombre.trim() == '';
      this.errores.telefono2 = this.recomendado.telefono == null || this.recomendado.telefono.trim() == '';
      this.errores.ciudad = this.recomendado.ciudad == null || this.recomendado.ciudad.trim() == '';
      this.errores.rubro = this.recomendado.rubro == null || this.recomendado.rubro.trim() == '';

      let existError = Object.keys(this.errores).some(key => this.errores[key]);
      if (existError) return;

      this.loading = true;
      spinnerService.show();
      try {
        let obj = {
          Nombre: this.recomendado.nombre,
          Telefono: this.recomendado.telefono,
          Ciudad: this.recomendado.ciudad,
          Rubro: this.recomendado.rubro,
          Comentario: this.recomendado.comentario,
          FechaRegistro: new Date(),
          
          DocRecomendador: this.recomendador.ruc,
          NombreRecomendador: this.recomendador.nombre,
          TelefonoRecomendador: this.recomendador.telefono,

          IdAsesor: 0,
          IdContador:  0,
        };

        await ClientesService.createRecomendado(obj);
        Utils.mostrarMensajeExito('Se ha guardado exitosamente');
        this.loading = false;
        this.$router.push({
          path: `/felicidades-recomendado-cliente`
        });
      } catch (error) {
        this.loading = false;
        Utils.mostrarMensajeAdvertencia(error.Message || 'Ocurrio un error')
      } finally{
        spinnerService.hide();
      }

    }
  }
};

</script>
<template>
  <div class="space"></div>
  <div class="container conts">
    <div class="row">
      <div class="col"></div>
      <div class="col-sm-9">
        <div class="recuadro bg-white mt-5 mb-5">
          <div class="text-center head bg-primary bg-gradient text-white p-4">
            <h1>REGISTRA A TU RECOMENDADO</h1>
          </div>
          <div class="card-body p-5">
            <form id="regis" action="/recomendado" method="POST">
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Por favor completa tus datos como recomendador</h2>
                    <p>Con estos datos podremos asignarte premios y beneficios como por recomendarnos</p>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="nombre" class="form-control-lg">RUC de tu empresa como cliente SMART</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="recom_afiliado_doc"
                      id="recom_afiliado_doc" maxlength="20" v-model="recomendador.ruc" v-bind:class="{ 'invalid': errores.ruc }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="nombre" class="form-control-lg">Nombre Completo</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="recom_afiliado_nombre"
                      v-model="recomendador.nombre" v-bind:class="{ 'invalid': errores.nombreCompleto }" maxlength="255">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="ciudad" class="form-control-lg">Teléfono</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="recom_afiliado_tel"
                      id="recom_afiliado_tel" v-model="recomendador.telefono" v-bind:class="{ 'invalid': errores.telefono1 }" maxlength="20">
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col">
                    <h2>Por favor completa los datos de tu recomendado</h2>
                  </div>
                </div>
              </div>
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="nombre" class="form-control-lg">Nombre Completo</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="recom_nombre" id="recom_nombre"
                      maxlength="255" v-model="recomendado.nombre" v-bind:class="{ 'invalid': errores.nombre }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="nombre" class="form-control-lg">Teléfono</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="recom_telefono" id="recom_telefono"
                      maxlength="20" v-model="recomendado.telefono" v-bind:class="{ 'invalid': errores.telefono2 }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="ciudad" class="form-control-lg">Ciudad</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="recom_ciudad" id="recom_ciudad"
                      maxlength="50" v-model="recomendado.ciudad" v-bind:class="{ 'invalid': errores.ciudad }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="rubro" class="form-control-lg">Rubro del negocio</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="recom_rubro" id="recom_rubro"
                      maxlength="50" v-model="recomendado.rubro" v-bind:class="{ 'invalid': errores.rubro }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="rubro" class="form-control-lg">Comentarios adicionales</label>
                  </div>
                  <div class="col-sm-7">
                    <textarea class="form-control form-control-lg" name="recom_comentario" id="recom_comentario" rows="3" v-model="recomendado.comentario" v-bind:class="{ 'invalid': errores.comentario }"
                      maxlength="255" placeholder="OPCIONAL"></textarea>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <input type="hidden" name="recom_fec_registro" id="recom_fec_registro">
                  <div class="col"><a @click="btnCancelar_click" class="btn btn-danger form-control btn-lg">Cancelar</a></div>
                  <div class="col"></div>
                  <div class="col"><button type="button" id="guardar" class="btn btn-primary form-control btn-lg"
                      @click="btnGuardar_click">Guardar</button></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>
  </div>
</template>